import Message from './src/main.js';
export default Message;



// WEBPACK FOOTER //
// ./src/components/message/index.js